// Dark-mode-aware chart theme for the FinOps panels. The app toggles dark mode
// with a `dark` class on <html> (tailwind darkMode:"class"); recharts styles are
// inline SVG attributes that Tailwind can't reach, so charts must re-render with
// the right ink when the class flips. A hardcoded light grid (#e2e8f0) on the
// dark surface glows like a wireframe — the single most visible chart defect in
// dark mode.

import { useSyncExternalStore } from 'react';

function subscribe(cb) {
  const obs = new MutationObserver(cb);
  obs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  return () => obs.disconnect();
}
const getSnapshot = () => document.documentElement.classList.contains('dark');

export function useIsDark() {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

// One theme object per mode: recessive grid, quiet axis ink (darker text on the
// light surface for contrast; slate-400 on dark), and a subtle hover cursor.
export function useChartTheme() {
  const dark = useIsDark();
  return {
    dark,
    axis: { stroke: dark ? '#94a3b8' : '#64748b', fontSize: 11, tickLine: false, axisLine: false },
    grid: { stroke: dark ? '#334155' : '#e2e8f0', strokeDasharray: '3 3', opacity: dark ? 0.5 : 0.6 },
    cursor: { stroke: dark ? '#475569' : '#cbd5e1', strokeWidth: 1 },
    neutralLine: dark ? '#64748b' : '#94a3b8',
  };
}
